import React, {useRef, useState} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {Log} from 'utils';
import ButtonBorder from './ButtonBorder';
import Div from './Div';
const Calendar_Another_Type = () => {
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  const value = useRef<'from' | 'to'>('from');
  const [isShowCalendar, setIsShowCalendar] = useState(false);
  const divRef = useRef<any>(null);
  const dudechange = a => {
    setIsShowCalendar(false);
    if (value.current == 'from') {
      setFromDate(a);
    } else {
      setToDate(a);
    }
  };
  Log('change', {
    fromDate,
    toDate,
  });
  return (
    <>
      <ButtonBorder
        title="12312312"
        onPress={() => {
          setIsShowCalendar(true);
          Log('divRef', divRef.current);
        }}
      />
      {isShowCalendar && (
        <DatePicker
          autoFocus={true}
          onSelect={date => dudechange(date)} //when day is clicked
          onChange={date => dudechange(date)} //only when value has changed
          popperPlacement="bottom"
          customInput={
            <Div
              divRef={divRef}
              width={80}
              height={40}
              backgroundColor="red"></Div>
          }
        />
      )}
    </>
  );
};

export default React.memo(Calendar_Another_Type);
